import { useContext } from "react"
import { IRegistrationRootStore } from "../stores/registrationRootStore"
import { RegistrationStoreContext } from "../context"

const useStores = (): IRegistrationRootStore =>
  useContext<IRegistrationRootStore>(RegistrationStoreContext)

export default useStores
